import React from 'react';
import "./css/about.css";
import solar from "./media/solar-farm.jpg";
import storage from "./media/storage.PNG";
import nem from "./media/cpuc.jpg";
import AddressMap from './AddressMap'; // Import the new component
import Seo from './Seo';

class About extends React.Component {

  render() {
    return (
      <div>
        <Seo
          title="About Us | PV Solar San Diego"
          description="PV Solar is a family-owned, PE-led solar installer serving San Diego County, with 25+ years of combined experience — residential, commercial, and standalone PE designs. Se habla español."
          path="/about"
        />
        <div className="about-container">
          <div className="block about">
            About
          </div>
          <div className="block text">
            <div className="content">
              Family Business
              <div className="subtext">PV Solar is a family-owned business serving San Diego County, with over 25 years of combined experience across our team. We treat every customer like a neighbor — and our team speaks Spanish, so language is never a barrier to going solar. Hablamos español.</div>
            </div>
          </div>
          <div className="block text">
            <div className="content">
              Professional Engineering
              <div className="subtext">PV Solar is led by a California-licensed Professional Engineer (PE) — Electrical, Power. Every project is engineered to code: load calculations, single-line diagrams, and plan sets built to SDG&amp;E and county standards. Need only the engineering? We also sell standalone, permit-ready PE designs for homeowners and contractors — whether or not we do the installation.</div>
            </div>
          </div>
          <div className="block split">
            <div className="half text">
              <div className="content">
                Location
                <div className="subtext">We proudly serve the entire San Diego County, including Chula Vista, Oceanside, Escondido, Carlsbad, Jamul, Bonita, Del Mar, La Jolla, and more.</div>
              </div>
            </div>
            <div className="half">
              <AddressMap />
            </div>
          </div>
          <div className="block split">
            <div className="half">
              <img src={solar} alt="Solar Farm" className="full-image"/>
            </div>
            <div className="half text">
              <div className="content">
                Solar Panels
                <div className="subtext">Transform your home with our advanced, sustainable solar technology, reducing energy costs and enhancing home value through eco-friendly, long-term savings. Embrace renewable energy for efficient, self-sufficient power, leading the way in energy innovation and eco-conscious living.</div>
              </div>
            </div>
          </div>
          <div className="block split">
            <div className="half text">
              <div className="content">
                Batteries
                <div className="subtext">Enhance energy independence and savings with our advanced battery systems, designed for outage protection and grid support, complete with convenient remote control and instant alerts.</div>
              </div>
            </div>
            <div className="half">
              <img src={storage} alt="Enphase Energy Storage" className="full-image"/>
            </div>
          </div>
          <div className="block split">
            <div className="half">
              <img src={nem} alt="California Public Utilities Commission" className="full-image"/>
            </div>
            <div className="half text">
              <div className="content">
                NEM 3.0
                <div className="subtext">Under NEM 3.0, while compensation for solar energy drops from $0.30 to $0.08 per kWh, pairing solar panels with batteries maximizes benefits. This combination allows homeowners to store and use their solar energy efficiently, reducing grid dependence and enhancing sustainability, thus offsetting the reduced feed-in tariffs.</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile-about-container">
          <div className="mobile-block about">
            About
          </div>
          <div className="mobile-block text family">
            <div className="content">
              Family Business
              <div className="subtext">PV Solar is a family-owned business serving San Diego County, with over 25 years of combined experience across our team. We treat every customer like a neighbor — and our team speaks Spanish, so language is never a barrier to going solar. Hablamos español.</div>
            </div>
          </div>
          <div className="mobile-block text pe">
            <div className="content">
              Professional Engineering
              <div className="subtext">PV Solar is led by a California-licensed Professional Engineer (PE) — Electrical, Power. Every project is engineered to code: load calculations, single-line diagrams, and plan sets built to SDG&amp;E and county standards. Need only the engineering? We also sell standalone, permit-ready PE designs for homeowners and contractors — whether or not we do the installation.</div>
            </div>
          </div>
          <div className="mobile-block">
            <AddressMap />
          </div>
          <div className="mobile-block text">
            <div className="content">
              Location
              <div className="subtext">We proudly serve the entire San Diego County, including Chula Vista, Oceanside, Escondido, Carlsbad, Jamul, Bonita, Del Mar, La Jolla, and more.</div>
            </div>
          </div>
          <div className="mobile-block">
            <img src={solar} alt="solar" className="full-image"/>
          </div>
          <div className="mobile-block text">
            <div className="content">
              Solar Panels
              <div className="subtext">Transform your home with our advanced, sustainable solar technology, reducing energy costs and enhancing home value through eco-friendly, long-term savings. Embrace renewable energy for efficient, self-sufficient power, leading the way in energy innovation and eco-conscious living.</div>
            </div>
          </div>
          <div className="mobile-block">
            <img src={storage} alt="storage" className="full-image"/>
          </div>
          <div className="mobile-block text">
            <div className="content">
              Batteries
              <div className="subtext">Enhance energy independence and savings with our advanced battery systems, designed for outage protection and grid support, complete with convenient remote control and instant alerts.</div>
            </div>
          </div>
          <div className="mobile-block">
            <img src={nem} alt="cpuc" className="full-image"/>
          </div>
          <div className="mobile-block text">
            <div className="content">
              NEM 3.0
              <div className="subtext">Under NEM 3.0, while compensation for solar energy drops from $0.30 to $0.08 per kWh, pairing solar panels with batteries maximizes benefits. This combination allows homeowners to store and use their solar energy efficiently, reducing grid dependence and enhancing sustainability, thus offsetting the reduced feed-in tariffs.</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;